// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1FNW2","subheader":"ReorderModal_subheader__2WspN","listWrap":"ReorderModal_listWrap__2tG8V"};